import React from 'react';
import { Redirect } from '@reach/router';
import useLink from '@bottlebooks/gatsby-theme-event/src/useLink';
import BaseLayout from '@bottlebooks/gatsby-theme-event/src/components/Layout/BaseLayout';

export default function ProducerTemplate({ pageContext }) {
  const link = useLink();
  return (
    <BaseLayout>
      <Redirect to={link.exhibitor({ exhibitorId: pageContext.exhibitorId })} />
    </BaseLayout>
  );
}
